import { GET_MAQUINAS_OF_MAE_MAQUINA, DELETE_MAQUINA, UPDATE_DETALLES_MAQUINA, UPDATE_DETALLES_NEW_MAQUINA } from '../constants/action_types';

const initialState = { maquinas: [], noSpinner: false, refresh: false, isLoading: false };

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_MAQUINAS_OF_MAE_MAQUINA + "_SUCCESS":
            return { maquinas: action.payload.data, noSpinner: true, refresh: false };
        case DELETE_MAQUINA + "_SUCCESS":
            return state;
        case UPDATE_DETALLES_MAQUINA:
            return { ...state, isLoading: true };
        case UPDATE_DETALLES_MAQUINA + "_SUCCESS":
            return { ...state, isLoading: false };
        case UPDATE_DETALLES_MAQUINA + "_FAILURE":
            return { ...state, isLoading: false };
        case UPDATE_DETALLES_NEW_MAQUINA:
            return { ...state, isLoading: true };
        case UPDATE_DETALLES_NEW_MAQUINA + "_FAILURE":
            return { ...state, isLoading: false };
        case UPDATE_DETALLES_NEW_MAQUINA + "_SUCCESS":
            return { maquinas: [], noSpinner: true, refresh: true, isLoading: false };
        default:
            return state;
    }

}